module.exports = "<h2 id=styling>Styling</h2> <p>Let&#39;s talk about styling with <code>lines</code> by adding country borders. Since our GeoJSON represents each country as a polygon or multipolygon, we know that there are edges (or lines) in between each vertex (or point). We can use the <code>lines</code> style to draw these borders. And since we&#39;re using the same layer of data (<code>_countryStyle</code>), we can simply declare a new style under the <code>draw</code> block.</p> <p>[section] { &quot;type&quot;: &quot;tangram&quot;, &quot;src&quot;: &quot;styling.yaml&quot;, &quot;lines&quot;: &quot;18-19&quot; } [section]</p>";


/*****************
 ** WEBPACK FOOTER
 ** ./Assets/markdown/styling1.md
 ** module id = 687
 ** module chunks = 1
 **/